// frontend/src/api/trackingAPI.js
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://techiohisab.com/api';

const trackingAPI = {
  // AWB Tracking
  async createAWBTracking(awbData) {
    try {
      const response = await fetch(`${API_BASE_URL}/tracking/awb`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(awbData),
      });
      if (!response.ok) throw new Error('Failed to create AWB tracking');
      return await response.json();
    } catch (error) {
      console.error('Error creating AWB tracking:', error);
      throw error;
    }
  },

  async trackAWB(awbNumber) {
    try {
      const response = await fetch(`${API_BASE_URL}/tracking/awb/${awbNumber}`);
      if (!response.ok) throw new Error('Failed to track AWB');
      return await response.json();
    } catch (error) {
      console.error('Error tracking AWB:', error);
      throw error;
    }
  },

  async getAWBHistory(awbNumber) {
    try {
      const response = await fetch(`${API_BASE_URL}/tracking/awb/${awbNumber}/history`);
      if (!response.ok) throw new Error('Failed to get AWB history');
      return await response.json();
    } catch (error) {
      console.error('Error getting AWB history:', error);
      throw error;
    }
  },

  // AWS ID Tracking
  async trackAWSID(awsId) {
    try {
      const response = await fetch(`${API_BASE_URL}/tracking/aws/${awsId}`);
      if (!response.ok) throw new Error('Failed to track AWS ID');
      return await response.json();
    } catch (error) {
      console.error('Error tracking AWS ID:', error);
      throw error;
    }
  },

  async getAWSDispatchHistory(awsId) {
    try {
      const response = await fetch(`${API_BASE_URL}/tracking/aws/${awsId}/dispatch`);
      if (!response.ok) throw new Error('Failed to get AWS dispatch history');
      return await response.json();
    } catch (error) {
      console.error('Error getting AWS dispatch history:', error);
      throw error;
    }
  },

  // Customer Returns
  async getCustomerReturns() {
    try {
      const response = await fetch(`${API_BASE_URL}/customer-returns`);
      if (!response.ok) throw new Error('Failed to get customer returns');
      return await response.json();
    } catch (error) {
      console.error('Error getting customer returns:', error);
      throw error;
    }
  },

  async createCustomerReturn(returnData) {
    try {
      const response = await fetch(`${API_BASE_URL}/customer-returns`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(returnData),
      });
      if (!response.ok) throw new Error('Failed to create customer return');
      return await response.json();
    } catch (error) {
      console.error('Error creating customer return:', error);
      throw error;
    }
  },

  async moveToManufacturing(returnId, manufacturingData) {
    try {
      const response = await fetch(`${API_BASE_URL}/customer-returns/${returnId}/move-to-manufacturing`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(manufacturingData),
      });
      if (!response.ok) throw new Error('Failed to move to manufacturing');
      return await response.json();
    } catch (error) {
      console.error('Error moving to manufacturing:', error);
      throw error;
    }
  },

  // Flipkart Networth Calculation
  async getFlipkartInTransitNetworth() {
    try {
      const response = await fetch(`${API_BASE_URL}/analytics/flipkart/in-transit-networth`);
      if (!response.ok) throw new Error('Failed to get Flipkart networth');
      return await response.json();
    } catch (error) {
      console.error('Error getting Flipkart networth:', error);
      throw error;
    }
  },

  // Barcode Scanning
  async scanProduct(barcode) {
    try {
      const response = await fetch(`${API_BASE_URL}/products/scan/${barcode}`);
      if (!response.ok) throw new Error('Failed to scan product');
      return await response.json();
    } catch (error) {
      console.error('Error scanning product:', error);
      throw error;
    }
  },

  async sellScannedProducts(productsData) {
    try {
      const response = await fetch(`${API_BASE_URL}/sales/bulk-scan`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(productsData),
      });
      if (!response.ok) throw new Error('Failed to sell scanned products');
      return await response.json();
    } catch (error) {
      console.error('Error selling scanned products:', error);
      throw error;
    }
  }
};

export default trackingAPI;
